<template>
    <div class="bottom-warning">
        <div class="bottom-warning-message">
            {{ $t("The data space is not properly configured.") + " " }}
            {{ $t("Complete the configuration in order to start interacting with other participants.") }}
        </div>
        <div class="bottom-warning-buttons">
            <button type="button" class="btn btn-primary" @click="showConfigModal"><i class="fas fa-cog"></i> {{ $t("Configure") }}</button>
            <button type="button" class="btn btn-secondary" @click="dismiss"><i class="fas fa-times"></i> {{ $t("Dismiss") }}</button>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "DataSpaceMissingConfigWarning",
    emits: ["show-config-modal", "dismiss"],
    methods: {
        dismiss: function () {
            this.$emit("dismiss");
        },

        showConfigModal: function () {
            this.$emit("show-config-modal");
        },
    },
});
</script>
